import script from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPluginManage.vue?vue&type=style&index=0&id=00963282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00963282"]])

export default __exports__